import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, HelpCircle, Calendar } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
import { Breadcrumbs } from '../components/Breadcrumbs';

const featuredArticles = [
  {
    slug: 'beste-eid-geschenke-2026',
    title: 'Die besten Eid Geschenke 2026: Der ultimative Guide',
    description: 'Ein umfassender Ratgeber mit über 50 Geschenkideen für Eid ul Fitr und Eid ul Adha – für jeden Empfänger und jedes Budget.',
    category: 'Ultimativer Guide',
    readTime: '12 Min.',
  },
  {
    slug: 'eid-ul-adha-geschenkideen',
    title: 'Eid ul Adha Geschenkideen: Bedeutungsvolle Präsente zum Opferfest',
    description: 'Alles über das Schenken zu Eid ul Adha – Geschichte, Traditionen und die schönsten Geschenkideen für das Opferfest.',
    category: 'Opferfest Special',
    readTime: '10 Min.',
  },
  {
    slug: 'ramadan-geschenke',
    title: 'Ramadan Geschenke: Die schönsten Ideen für den Fastenmonat',
    description: 'Von Iftar-Körben bis zu spirituellen Präsenten – ein umfassender Guide zu bedeutungsvollen Geschenken während des Ramadan.',
    category: 'Ramadan',
    readTime: '10 Min.',
  },
];

const categories = [
  {
    title: 'Geschenkideen',
    articles: [
      { slug: '25-eid-geschenke-kinder', title: 'Die 25 besten Eid Geschenke für Kinder 2026', readTime: '15 Min.' },
      { slug: '10-geschenke-maenner-eid', title: '10 Eid Geschenke für Männer, die alles haben', readTime: '8 Min.' },
      { slug: '15-geschenke-frauen-eid', title: '15 elegante Eid Geschenke für Frauen', readTime: '10 Min.' },
      { slug: 'geschenke-ganze-familie-eid', title: 'Eid Geschenke für die ganze Familie', readTime: '8 Min.' },
      { slug: 'guenstige-eid-geschenke', title: 'Günstige Eid Geschenke unter 20€', readTime: '7 Min.' },
      { slug: 'luxus-eid-geschenke', title: 'Luxus Eid Geschenke: Premium-Ideen', readTime: '8 Min.' },
      { slug: 'personalisierte-geschenke-eid', title: 'Personalisierte Geschenke zu Eid', readTime: '8 Min.' },
      { slug: 'diy-geschenke-eid', title: 'DIY Geschenke zu Eid selber machen', readTime: '10 Min.' },
      { slug: 'geschenkboxen-eid', title: 'Eid Geschenkboxen: Die schönsten Sets', readTime: '7 Min.' },
    ],
  },
  {
    title: 'Kinder & Familie',
    articles: [
      { slug: 'halal-suessigkeiten-deutschland', title: 'Halal Süßigkeiten in Deutschland: Der große Guide', readTime: '10 Min.' },
      { slug: 'islamische-buecher-kinder', title: 'Islamische Kinderbücher: Die Top-Empfehlungen', readTime: '9 Min.' },
      { slug: 'ramadan-kalender-selber-machen', title: 'Ramadan Kalender selber machen: DIY-Anleitung', readTime: '10 Min.' },
      { slug: 'eid-kleidung-kinder', title: 'Eid Kleidung für Kinder: Festliche Outfits', readTime: '8 Min.' },
      { slug: 'ramadan-aktivitaeten-kinder', title: 'Ramadan Aktivitäten für Kinder', readTime: '9 Min.' },
      { slug: 'eid-rezepte-kinder', title: 'Eid Rezepte für Kinder: Einfach & Lecker', readTime: '8 Min.' },
      { slug: 'eid-spiele-quiz', title: 'Eid Spiele und Quiz für die ganze Familie', readTime: '7 Min.' },
    ],
  },
  {
    title: 'Dekoration & Lifestyle',
    articles: [
      { slug: 'minimalistische-eid-deko', title: 'Minimalistische Eid Dekoration: Weniger ist mehr', readTime: '8 Min.' },
      { slug: 'eid-deko-ideen', title: 'Eid Deko Ideen für Zuhause', readTime: '9 Min.' },
      { slug: 'diy-tischdeko-eid', title: 'DIY Tischdeko für das Eid-Festmahl', readTime: '8 Min.' },
      { slug: 'ramadan-lichter-deko', title: 'Ramadan Lichter & Laternen: Stimmungsvolle Deko', readTime: '7 Min.' },
      { slug: 'moderne-muslimische-wohnideen', title: 'Moderne muslimische Wohnideen für Ramadan & Eid', readTime: '10 Min.' },
    ],
  },
  {
    title: 'Essen & Kulinarik',
    articles: [
      { slug: 'eid-fruehstueck-ideen', title: 'Eid Frühstück Ideen: Das perfekte Festmahl', readTime: '10 Min.' },
      { slug: 'ramadan-iftar-rezepte', title: 'Ramadan Iftar Rezepte: Traditionell & Modern', readTime: '12 Min.' },
      { slug: 'eid-suessigkeiten-selber-machen', title: 'Eid Süßigkeiten selber machen: 10 Rezepte', readTime: '10 Min.' },
      { slug: 'dattelsorten-ramadan', title: 'Die besten Dattelsorten für Ramadan', readTime: '8 Min.' },
    ],
  },
  {
    title: 'Spiritualität & Wissen',
    articles: [
      { slug: 'ramadan-fuer-anfaenger', title: 'Ramadan für Anfänger: Alles was du wissen musst', readTime: '12 Min.' },
      { slug: 'bedeutung-eid-ul-adha', title: 'Die Bedeutung von Eid ul Adha: Geschichte & Bräuche', readTime: '10 Min.' },
      { slug: 'zakat-sadaqah-eid', title: 'Zakat und Sadaqah: Geben und Schenken im Islam', readTime: '10 Min.' },
    ],
  },
  {
    title: 'Praktisches & Feiern',
    articles: [
      { slug: 'eid-party-planen', title: 'Eid Party planen: Der komplette Guide', readTime: '10 Min.' },
      { slug: 'eid-gruesse-wuensche', title: 'Eid Mubarak Grüße: Die schönsten Formulierungen', readTime: '8 Min.' },
      { slug: 'last-minute-eid-geschenke', title: 'Last Minute Eid Geschenke: Schnelle Ideen', readTime: '8 Min.' },
      { slug: 'was-ist-eid', title: 'Was ist Eid? Ein Leitfaden für Freunde und Nachbarn', readTime: '9 Min.' },
      { slug: 'top-10-eid-geschenke-kinder', title: 'Top 10 Eid Geschenke für Kinder 2026', readTime: '5 Min.' },
      { slug: 'eid-mubarak-tradition-moderne', title: 'Eid Mubarak: Tradition trifft Moderne', readTime: '6 Min.' },
    ],
  },
];

export default function RatgeberPage() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]" data-testid="ratgeber-page">
      <SEOHead
        title="Eid Geschenke Ratgeber: 30+ Artikel zu Eid, Ramadan & Schenken"
        description="Über 30 hilfreiche Ratgeber-Artikel mit Tipps und Inspiration rund um Eid, Ramadan und das Schenken. Geschenkideen, Rezepte, Deko und mehr."
        canonical="/ratgeber"
      />
      {/* Hero */}
      <section className="py-16 md:py-24 bg-[#F5F5F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Breadcrumbs items={[{ label: 'Ratgeber', path: '/ratgeber' }]} />
          <div className="max-w-3xl mt-4">
            <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-4 block">
              Ratgeber & Tipps
            </span>
            <h1 className="font-serif text-4xl md:text-5xl font-medium text-[#2C332E] mb-6 leading-tight">
              Eid Geschenke Ratgeber
            </h1>
            <p className="text-lg text-[#6B7280] leading-relaxed">
              Über 30 hilfreiche Artikel mit Tipps und Inspiration rund um Eid, Ramadan
              und das Schenken. Finde das perfekte Eid Mubarak Geschenk für jeden Anlass.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-8 flex items-center gap-3">
            <BookOpen className="w-6 h-6 text-[#4A5D4F]" />
            Top-Ratgeber
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {featuredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/ratgeber/${article.slug}`}
                className="group p-6 bg-[#4A5D4F] rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300"
                data-testid={`featured-article-${article.slug}`}
              >
                <span className="px-2 py-1 bg-white/20 rounded-full text-xs font-medium text-white mb-3 inline-block">
                  {article.category}
                </span>
                <h3 className="font-serif text-xl font-medium text-white mb-2 group-hover:text-[#D4C5A9] transition-colors">
                  {article.title}
                </h3>
                <p className="text-white/70 text-sm mb-4">
                  {article.description}
                </p>
                <span className="inline-flex items-center text-[#D4C5A9] text-sm font-medium group-hover:gap-2 gap-1 transition-all">
                  Artikel lesen
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>

          {/* Article Categories */}
          {categories.map((category) => (
            <div key={category.title} className="mb-12">
              <h3 className="font-serif text-xl font-medium text-[#2C332E] mb-4 pb-2 border-b border-[#E5E7EB]">
                {category.title}
              </h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {category.articles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/ratgeber/${article.slug}`}
                    className="group p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300"
                    data-testid={`article-${article.slug}`}
                  >
                    <h4 className="font-medium text-[#2C332E] mb-2 group-hover:text-[#4A5D4F] transition-colors text-sm">
                      {article.title}
                    </h4>
                    <div className="flex items-center justify-between">
                      <span className="flex items-center gap-1 text-xs text-[#6B7280]">
                        <Calendar className="w-3 h-3" />
                        {article.readTime}
                      </span>
                      <ArrowRight className="w-3 h-3 text-[#4A5D4F] opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-20 bg-[#F5F5F0]" id="faq">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-4 flex items-center gap-3">
            <HelpCircle className="w-6 h-6 text-[#4A5D4F]" />
            Häufig gestellte Fragen (FAQ)
          </h2>
          <p className="text-[#6B7280] mb-10">
            Antworten auf die wichtigsten Fragen rund um Eid Geschenke
          </p>

          <div className="space-y-4">
            {[
              {
                q: 'Was schenkt man zu Eid?',
                a: 'Zu Eid schenkt man traditionell Süßigkeiten, Datteln, Parfums oder neue Kleidung. Moderne Geschenkideen umfassen auch Bücher, Schmuck, Wellness-Sets oder personalisierte Geschenke. Wichtig ist, dass das Geschenk von Herzen kommt und Wertschätzung ausdrückt. Für Kinder eignen sich besonders islamische Kinderbücher, Spielzeug oder Eid-Überraschungsboxen.'
              },
              {
                q: 'Wann ist Eid ul Fitr 2026?',
                a: 'Eid ul Fitr 2026 wird voraussichtlich am 20. März 2026 gefeiert (nach dem islamischen Kalender am 1. Shawwal 1447). Das genaue Datum hängt von der Mondsichtung ab und kann je nach Region um einen Tag variieren. Eid ul Fitr markiert das Ende des Fastenmonats Ramadan und wird auch als "Fest des Fastenbrechens" bezeichnet.'
              },
              {
                q: 'Wann ist Eid ul Adha 2026?',
                a: 'Eid ul Adha 2026 wird voraussichtlich am 27. Mai 2026 gefeiert (10. Dhul-Hiddscha 1447). Das Opferfest beginnt am zehnten Tag des islamischen Monats Dhul-Hiddscha und dauert traditionell vier Tage. Es ist eines der wichtigsten Feste im Islam und erinnert an die Bereitschaft des Propheten Ibrahim, seinen Sohn zu opfern.'
              },
              {
                q: 'Welche Eid Geschenke eignen sich für Kinder?',
                a: 'Für Kinder eignen sich besonders: Islamische Kinderbücher (z.B. "Mama, was ist Ramadan?"), Eid-Überraschungsboxen mit Süßigkeiten und Spielzeug, Kreativ-Sets zum Basteln, islamische Lernspiele und Quiz-Karten, Kuscheltiere mit Eid-Outfit, Malbücher mit islamischen Motiven, bunte Gebetsketten für kleine Hände, oder Eid-Dekoration fürs Kinderzimmer.'
              },
              {
                q: 'Was sind passende Eid Geschenke für Frauen?',
                a: 'Beliebte Eid Geschenke für Frauen sind: Luxuriöse Parfum-Sets (z.B. Swiss Arabian oder RITUALS), hochwertige Schmuckstücke, Home-Spa und Wellness-Sets, elegante Schals oder Hijabs, Duftkerzen mit orientalischen Düften wie Oud oder Amber, sowie personalisierte Geschenke wie gravierter Schmuck.'
              },
              {
                q: 'Was sind passende Eid Geschenke für Männer?',
                a: 'Für Männer eignen sich: Attar oder Oud Parfumöle, hochwertige Gebetsketten (Tasbih), Lederwaren wie Geldbörsen, elegante Armbanduhren, Pflegesets mit orientalischen Düften, islamische Bücher oder Quran-Übersetzungen, sowie moderne Gadgets wie digitale Quran-Player.'
              },
              {
                q: 'Gibt man zu Eid Geld?',
                a: 'Ja, Geldgeschenke zu Eid sind traditionell und weit verbreitet, besonders von älteren Familienmitgliedern an Kinder (ähnlich dem "Eidi" in vielen Kulturen). Es ist eine schöne Geste, das Geld in einem hübschen Umschlag mit einer persönlichen Karte zu überreichen. Alternativ kann man auch Gutscheine verschenken.'
              },
            ].map((faq, index) => (
              <details
                key={index}
                className="group bg-white rounded-xl shadow-sm overflow-hidden"
              >
                <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-[#FDFCF8] transition-colors">
                  <h3 className="font-medium text-[#2C332E] pr-4">{faq.q}</h3>
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center group-open:rotate-45 transition-transform">
                    <span className="text-[#4A5D4F] text-xl leading-none">+</span>
                  </span>
                </summary>
                <div className="px-6 pb-6 pt-0">
                  <p className="text-[#6B7280] leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
